export default __webpack_public_path__ + "static/media/trackdays-3.6f9af6ba.jpg";